import React, {useState, useEffect} from 'react';
import { Gallery } from "react-grid-gallery";
import axios from 'axios';
import './style.css';
import Modal from './modal';

const MyGallery = () => {
  const [images, setImages] = useState();
  const [currentIndex, setCurrentIndex] = useState(null);
  const [clickedImage, setClickedImage] = useState(null);

  const { innerWidth: width } = window;
  // const hasSelected = images?.some((image) => image?.isSelected);

  useEffect(() => {
    axios.get(`${window.location}/?rest_route=/wp/v2/gallery`)
    .then((res) => {
      let img = []
      res.data.forEach(el => {
        img.push({
          src: `${window.location}${el.src.replace("\\", "")}`,
          width: el.width,
          height: el.heigth
        })
      });
      setImages(img)
    })
    .catch((err) => {
        console.error(err)
    })
  },[])

  const hendleRotationRight = () => {
    if (currentIndex + 1 >= images.length) {
      setCurrentIndex(0)
      setClickedImage(images[0])
      return
    }
    setCurrentIndex(currentIndex + 1)
    setClickedImage(images[currentIndex + 1])
  }

  const hendleRotationLeft = () => {
    if (currentIndex - 1 > 0) {
      setCurrentIndex(images.length)
      setClickedImage(images[images.length])
      return
    }
    setCurrentIndex(currentIndex - 1)
    setClickedImage(images[currentIndex - 1])
  }

  const handleSelect = (index) => {
    console.log(images[index])
    setClickedImage(images[index]);
    setCurrentIndex(index)
  };

  if (images) {
    return (
      <div id='galeria' className='gallery-section'>
        <h2>Alguns dos nossos momentos em fotos!</h2>
        <Gallery  
          className='myGallery' 
          images={images ? images : []} 
          onClick={handleSelect}
          rowHeight={(width <= 500) ? 125 : 290}
          tileViewportStyle={{filter: 'grayscale(50%)'}}
        />
        {clickedImage && (
          <Modal 
            clickedImage={clickedImage} 
            hendleRotationRight={hendleRotationRight}
            hendleRotationLeft={hendleRotationLeft}
            setClickedImage={setClickedImage}
          />
        )}
      </div>
    );
  }
  return
}

export default MyGallery